import { createUpsell } from '../upsell';
export const bNp3KE = createUpsell({
    id: 'bNp3KE',
    desc: 'Upsell sequence for RH coach with conditional logic - UK, JOIN',
    seq: [
        {
            id: 'upsell-coach',
            onPurchase: [
                'upsell-yoga-healthy-back',
                'upsell-fast-food',
                'upsell-detox',
                'upsell-alcohol',
                'upsell-sweet-treats',
            ],
            onDecline: [
                'upsell-12-month',
                'upsell-yoga-healthy-back',
                'upsell-fast-food',
                'upsell-detox',
                'upsell-alcohol',
                'upsell-sweet-treats',
            ],
        },
    ],
});
